// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"530":"23d2d1b1","787":"b1b38e91","901":"fdc3e4e2","991":"053bddf0"}[chunkId] + ".chunk.js";
};